import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Pro2SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M4.348 3.58a5.25 5.25 0 0 1 7.956 0l2.782 3.23-1.094 1.271 1.027 1.106L16.646 7.3v-.979l-3.204-3.72c-2.693-3.127-7.537-3.127-10.23 0L.008 6.321v.98l3.203 3.72a6.748 6.748 0 0 0 7.197 2.018l-1.164-1.253a5.24 5.24 0 0 1-4.896-1.745l-2.782-3.23 2.782-3.23Zm3.978 1.23a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3.5 2a3.5 3.5 0 1 1 6.535 1.744l3.015 3.246.51.55-1.1 1.02-.51-.549-2.928-3.153A3.5 3.5 0 0 1 4.826 6.81Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Pro2SVG;
